import { render } from "./IssueDetail.vue?vue&type=template&id=994b129a&scoped=true"
import script from "./IssueDetail.vue?vue&type=script&lang=js"
export * from "./IssueDetail.vue?vue&type=script&lang=js"

import "./IssueDetail.vue?vue&type=style&index=0&id=994b129a&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-994b129a"]])

export default __exports__